import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PagesCoreRoutingModule } from './pages-core-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    PagesCoreRoutingModule
  ]
})
export class PagesCoreModule { }
